//スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//ナビゲーション用
$(function(){
	$('#gnav_btn').on('click', function(){
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$('header nav').removeClass('open').stop().slideUp(200);
			$('body').removeClass('add_overray');
		}else{
			$(this).addClass('open');
			$('header nav').addClass('open').stop().slideDown(600);
			$('body').addClass('add_overray');
		}
	});
	$('.outside').on('click', function(){
		$('#gnav_btn').removeClass('open');
		$('header nav').removeClass('open').stop().slideUp(200);
		$('body').removeClass('add_overray');
	});
	$('header nav a').on('click', function(){
		$('#gnav_btn').removeClass('open');
		$('header nav').removeClass('open').stop().slideUp(200);
		$('body').removeClass('add_overray');
	});
});


//スクロールフェードイン
/* 到達したら要素を表示させる */
function showElementAnimation() {
                    
	var element = document.getElementsByClassName('fadeIn');
	if(!element) return; // 要素がなかったら処理をキャンセル
						
	var showTiming = window.innerHeight > 768 ? 200 : 80; // 要素が出てくるタイミングはここで調整
	var scrollY = window.pageYOffset; //スクロール量を取得
	var windowH = window.innerHeight; //ブラウザウィンドウのビューポート(viewport)の高さを取得
					  
	for(var i=0;i<element.length;i++) { 
	  var elemClientRect = element[i].getBoundingClientRect(); 
	  var elemY = scrollY + elemClientRect.top; 
	  if(scrollY + windowH - showTiming > elemY) {
		element[i].classList.add('scrollin');
	  } else if(scrollY + windowH < elemY) {
	  // 上にスクロールして再度非表示にする場合はこちらを記述
		element[i].classList.remove('scrollin');
	  }
	}
}
showElementAnimation();
window.addEventListener('scroll', showElementAnimation);


//SVG
window.addEventListener('load', function(){
  deSVG('.desvg', true);
});


//ローディングアニメーション
//テキストのカウントアップ+バーの設定
$(function(){
	var bar = new ProgressBar.Line(splash_text, {//id名を指定
		easing: 'easeInOut',//アニメーション効果linear、easeIn、easeOut、easeInOutが指定可能
		duration: 1000,//時間指定(1000＝1秒)
		strokeWidth: 0.2,//進捗ゲージの太さ
		color: '#555',//進捗ゲージのカラー
		trailWidth: 0.2,//ゲージベースの線の太さ
		trailColor: '#bbb',//ゲージベースの線のカラー
		text: {//テキストの形状を直接指定				
			style: {//天地中央に配置
				position: 'absolute',
				left: '50%',
				top: '50%',
				padding: '0',
				margin: '-30px 0 0 0',//バーより上に配置
				transform:'translate(-50%,-50%)',
				//'font-size':'1rem',
				color: '#fff',
			},
			autoStyleContainer: false //自動付与のスタイルを切る
		},
		step: function(state, bar) {
			bar.setText(Math.round(bar.value() * 100) + ' %'); //テキストの数値
		}
	});
	
	//アニメーションスタート
	bar.animate(1.0, function () {//バーを描画する割合を指定します 1.0 なら100%まで描画します
		$("#splash_text").fadeOut(10);//フェイドアウトでローディングテキストを削除
		$(".loader_cover-up").addClass("coveranime");//カバーが上に上がるクラス追加
		$(".loader_cover-down").addClass("coveranime");//カバーが下に下がるクラス追加
		$("#splash").fadeOut();//#splashエリアをフェードアウト
	});
});


// 動きのきっかけとなるアニメーションの名前を定義
function fadeAnime(){
	// ふわっ
	$('.fadeTrigger').each(function(){ //fadeTriggerというクラス名が
	  var elemPos = $(this).offset().top-50;//要素より、50px上の
	  var scroll = $(window).scrollTop();
	  var windowHeight = $(window).height();
	  if (scroll >= elemPos - windowHeight){
	  $(this).addClass('fadeUp');// 画面内に入ったらfadeUpというクラス名を追記
	  }else{
	  $(this).removeClass('fadeUp');// 画面外に出たらfadeUpというクラス名を外す
	  }
	});
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
	fadeAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function(){
	fadeAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面が読み込まれたらすぐに動かしたい場合の記述


//スライドイン
function slideAnime(){
//====下に動くアニメーションここから===
	$('.downAnime').each(function(){
		var elemPos = $(this).offset().top-50;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll >= elemPos - windowHeight){
		// 下から上へ表示するクラスを付与
		// テキスト要素を挟む親要素（下）とテキスト要素を元位置でアニメーションをおこなう
		$(this).addClass("slideAnimeDownUp");
		// 要素を下枠外に移動しCSS アニメーションで下から元の位置に移動
		$(this).children(".downAnimeInner").addClass("slideAnimeUpDown");
		// 子要素は親要素のアニメーションに影響されないように逆の指定をし元の位置をキープするアニメーションをおこなう
		}else{
		// 下から上へ表示するクラスを取り除く
		$(this).removeClass("slideAnimeDownUp");
		$(this).children(".downAnimeInner").removeClass("slideAnimeUpDown");
		}
	});
}
// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
	slideAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面をスクロールをしたら動かしたい場合の記述


//ポップアップウィンドウ
$(function(){
	// 「.modal_open」をクリックしたらモーダルと黒い背景を表示する
	$('.modal_open').click(function(){
		// 黒い背景をbody内に追加
		$('body').append('<div class="modal_bg"></div>');
		$('.modal_bg').fadeIn();

		// data-targetの内容をIDにしてmodalに代入
		var modal = '#' + $(this).attr('data-target');
		
		// modalをフェードインで表示
		$(modal).fadeIn();
  
		// .modal_bgか.modal_closeをクリックしたらモーダルと背景をフェードアウトさせる
		$('.modal_bg, .modal_close').off().click(function(){
			$('.modal_box').fadeOut();
			$('.modal_bg').fadeOut('slow',function(){
				$('.modal_bg').remove();
			});
		});
	
		// .modal_switchを押すとモーダルを切り替える
		$('.modal_switch').click(function(){
			
			// 押された.modal_switchの親要素の.modal_boxをフェードアウトさせる
			$(this).parents('.modal_box').fadeOut();
			
			// 押された.modal_switchのdata-targetの内容をIDにしてmodalに代入
			var modal = '#' + $(this).attr('data-target');
			
			$(modal).fadeIn();
		});
	});
});

//ロゴフェードイン
/*
$(function(){
	var navPos = jQuery( '#header-logo' ).offset().top; // メイン画像の位置
	var navHeight = jQuery( '#header-logo' ).outerHeight(); // メイン画像の高さ
	jQuery( window ).on( 'scroll', function() {
		if ( jQuery( this ).scrollTop() > navPos ) {
			jQuery( 'body' ).css( 'padding-top', navHeight );
			jQuery( '#header-logo' ).addClass( 'm_fixed' );
		} else {
			jQuery( 'body' ).css( 'padding-top', 0 );
			jQuery( '#header-logo' ).removeClass( 'm_fixed' );
		}
	});
});*/

//英字ランダム
var arr = []
//初期値の設定
function TypingInit() {
	$('.js_typing').each(function (i) { //js_typingクラスを全て処理をおこなう
		arr[i] = new ShuffleText(this);//動作させるテキストを配列に格納
	});
}
//スクロールした際のアニメーションの設定
function TypingAnime() {
	$(".js_typing").each(function (i) {
		var elemPos = $(this).offset().top - 50;//要素より、50px上の
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll >= elemPos - windowHeight) {
			if(!$(this).hasClass("endAnime")){//endAnimeのクラスがあるかチェック
				arr[i].start();//配列で登録テキストのアニメーションをおこなう
				arr[i].duration = 800;//テキストが最終変化するまでの時間※規定値600
				$(this).addClass("endAnime");//１度アニメーションした場合はendAnimeクラスを追加
			}
		}else{
			$(this).removeClass("endAnime"); //範囲外にスクロールした場合はendAnimeのクラスを削除
		}
	});
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
	TypingAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
	TypingInit(); //初期設定
	TypingAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面が読み込まれたらすぐに動かしたい場合の記述


// ロゴ下テキストの切り替え 冬
$(window).on('load scroll', function() {
	fix_element3();
});
function fix_element3() {
	// 固定配置に使用する要素
	var $fixWrapper = $('.js-fix-wrapper3');
	var $fix = $('.js-fix3');
	var $fixArea = $('.js-fix-area3');

	// 要素がある場合のみ処理
	if($fixWrapper.length && $fix.length && $fixArea.length) {
		var fixTop = $fixWrapper.offset().top;
		var fixEnd = $fixArea.offset().top + $fixArea.height();
		var fixHeight = $fix.height();
		var winScroll = $(window).scrollTop();
		var winheight = $(window).height();
		// 開始位置を通過する前
		if(winScroll < fixTop) {
			$fix.removeClass('is-fixed');
		// 終了位置を通過した後
		} else if(winScroll > fixEnd - fixHeight) {
			$fix.removeClass('is-fixed');
		// 対象範囲内の場合
		} else {
			$fix.addClass('is-fixed');
		}
	}
}

// ロゴ下テキストの切り替え 夏
$(window).on('load scroll', function() {
	fix_element1();
});
function fix_element1() {
	// 固定配置に使用する要素
	var $fixWrapper = $('.js-fix-wrapper1');
	var $fix = $('.js-fix1');
	var $fixArea = $('.js-fix-area1');

	// 要素がある場合のみ処理
	if($fixWrapper.length && $fix.length && $fixArea.length) {
		var fixTop = $fixWrapper.offset().top;
		var fixEnd = $fixArea.offset().top + $fixArea.height();
		var fixHeight = $fix.height();
		var winScroll = $(window).scrollTop();
		var winheight = $(window).height();
		// 開始位置を通過する前
		if(winScroll < fixTop) {
			$fix.removeClass('is-fixed');
		// 終了位置を通過した後
		} else if(winScroll > fixEnd - fixHeight) {
			$fix.removeClass('is-fixed');
		// 対象範囲内の場合
		} else {
			$fix.addClass('is-fixed');
		}
	}
}

// ロゴ下テキストの切り替え 春
$(window).on('load scroll', function() {
	fix_element2();
  });
  function fix_element2() {
	// 固定配置に使用する要素
	var $fixWrapper = $('.js-fix-wrapper2');
	var $fix = $('.js-fix2');
	var $fixArea = $('.js-fix-area2');
	// 要素がある場合のみ処理
	if($fixWrapper.length && $fix.length && $fixArea.length) {
		var fixTop = $fixWrapper.offset().top-440;
		var fixEnd = $fixArea.offset().top + $fixArea.height();
		var fixHeight = $fix.height();
		var winScroll = $(window).scrollTop();
		var winheight = $(window).height();
		// 開始位置を通過する前
		if(winScroll < fixTop) {
			$fix.removeClass('is-fixed');
		// 終了位置を通過した後
		} else if(winScroll > fixEnd - fixHeight) {
			$fix.removeClass('is-fixed');
		// 対象範囲内の場合
		} else {
			$fix.addClass('is-fixed');
		}
	}
}
